<template>
  <div>
    <v-dialog :scrollable="true" v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Utilizar estructura</v-card-title>
        <v-card-text>
          <v-card-actions>
            <v-select
              v-bind:items="structures"
              v-model="structureName"
              item-text="structureName"
              item-value="structureName"
              label="Elegir estructura"
              bottom
              :loading="isLoadingStructures"
              :error-messages="checkingStructureNameMessages"
            >
              <template slot="selection" slot-scope="data">
                {{ `${data.item.structureName}${data.item.heritable ? ' - Heredable' : ''} ` }}
              </template>
              <template slot="item" slot-scope="data">
                {{ `${data.item.structureName}${data.item.heritable ? ' - Heredable' : ''} ` }}
              </template>
            </v-select>
            <v-btn :disabled="structureName === null" flat color="info" @click.native="openDetails()">
              <v-icon left dark>open_in_new</v-icon>
              <span class="hidden-xs-only">Ver estructura</span>
            </v-btn>  
          </v-card-actions>

          <v-text-field
            label="Nombre del Folder ($$FOLDER)"
            v-model="folderName"
          ></v-text-field>

          <v-checkbox label="Entrar a la carpeta" v-model="enterInFolder" color="primary"></v-checkbox>
          <v-checkbox label="Ocultar carpeta" v-model="hideFolder" color="primary"></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" flat @click.native="dialog = false">Cerrar</v-btn>
          <v-btn color="blue darken-1" :disabled="structureName === null" flat @click.native="buildStructure()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog :scrollable="true" v-model="structureItemsDialog" max-width="350px">
      <v-card>
        <v-card-title class="headline">Vista de estructura</v-card-title>
        <v-card-text>
          <flat-structure-item v-for="(i, $index) in selectedStructureItems" :key="$index" :item="i"></flat-structure-item> 
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" flat @click.native="structureItemsDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from '../../utils/eventBus'
import structureStorage from '../../storage/structureStorage'
import reportsStorage from '../../storage/reportsStorage'

import FlatStructureItem from '../structures/flat-structure-item.vue'

import find from 'lodash/find'

export default {
  name: 'paste-structure-form-dialog',
  created () {
    eventBus.$off('open-paste-structure-form-dialog')
    eventBus.$on('open-paste-structure-form-dialog', () => {
      // console.log('opened')
      this.dialog = true
      this.isLoadingStructures = true
      structureStorage.getStructures({
        onSuccess: (response) => {
          this.structures = response.data.rows
          this.isLoadingStructures = false
        },
        onError: (/* error */) => {
          // console.log(error)
          this.isLoadingStructures = false
          this.checkingStructureNameMessages = ['Ha habido un problema con el servidor']
        }
      })
    })
  },
  data () {
    return {
      isLoadingStructures: false,
      checkingStructureNameMessages: [],
      dialog: false,
      structures: [],
      selectedStructureItems: [],
      structureName: null,
      folderName: '',
      enterInFolder: true,
      hideFolder: true,
      structureItemsDialog: false
    }
  },
  methods: {
    openDetails () {
      this.selectedStructureItems = find(this.structures, i => i.structureName === this.structureName)['structureItems']
      this.structureItemsDialog = true
    },
    buildStructure () {
      let selectedStructureItems = find(this.structures, i => i.structureName === this.structureName)['structureItems']
      console.warn('!!!', JSON.stringify(selectedStructureItems, null, 2), selectedStructureItems)
      // return
      selectedStructureItems = selectedStructureItems.map(i => ({
        structureItemID: i.structureItemID,
        itemName: i.itemName,
        description: i.description.replace(i.folderName, this.folderName),
        labels: i.labels.replace(i.folderName, this.folderName),
        imageUrl: i.imageUrl,
        isFolder: i.isFolder
      }))
      const sendStructure = {
        folderName: this.folderName,
        containedBy: this.$route.params.folderID,
        hideFolder: this.hideFolder,
        items: selectedStructureItems
      }
      structureStorage.buildStructure({
        data: sendStructure,
        onSuccess: (response) => {
          console.info(response.data.rows)
          reportsStorage.addItems(response.data.rows)
          // emit to routes/main-page.vue
          eventBus.$emit('reload-items', {})
          if (this.enterInFolder) {
            this.$router.push(`/${response.data.folderID}`)
          }

          this.dialog = false
        },
        onError: () => {

        }
      })
    }
  },
  components: {
    FlatStructureItem
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/paste-structure-form-dialog.vue